
const baseUrl = "https://api.decluttersapp.com/api/v1"
export const baseUrl2 = "https://api.decluttersapp.com"

export default baseUrl;
